import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material'
import React, { useState } from 'react'
import useTranslate from '../../utils/i18n'
import { useNavigate } from 'react-router-dom'

const ModalLanguage = ({ open, onClose }) => {
  const { t } = useTranslate()
  const navigate = useNavigate()

  const getLang = localStorage.getItem('lang') || 'id'
  const [lang, setLang] = useState(getLang)

  function changeLanguage() {
    localStorage.setItem('lang', lang)
    navigate(0)
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{t('selectLang')}</DialogTitle>
      <DialogContent>
        <FormControl>
          <RadioGroup
            aria-labelledby="select-language"
            name="select-language"
            defaultValue={lang}
            onChange={(e) => setLang(e.target.value)}
          >
            <FormControlLabel value="id" control={<Radio />} label="Indonesia" />
            <FormControlLabel value="en" control={<Radio />} label="English" />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="warning" onClick={onClose}>
          {t('buttonLang.cancel')}
        </Button>
        <Button variant="contained" onClick={changeLanguage}>
          {t('buttonLang.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalLanguage
